// extracted by mini-css-extract-plugin
module.exports = {"keypad-btn":"KeypadButton_keypad-btn__23L-K","exponent":"KeypadButton_exponent__2x0_7"};